import { Box, FormControl, InputAdornment, Modal, TextField, Typography } from '@mui/material';
import React, { forwardRef, useEffect, useState } from 'react';
import LeftArrow from '../../../../../../../asset/svg/leftArrow.svg';
import '../../../../../../../scss/pages/Attendance/Component/Asset/Assets/Agreement/RegisteredAssetEffectiveDate/registeredAssetEffectiveDate.scss';
import SearchIcon from '@mui/icons-material/Search';
import requestEmptyIcon from '../../../../../../../asset/svg/requestEmptyIcon.svg'
import { ASSETS_REGISTER_PATH } from '../../../../../../../utils/Constants';
import { ADD_EFFECTIVEDATE_REGISTERED_ASSET, CLEAR_EFFECTIVE_DATE, HIDE_MODAL_SELECT_STORE, POST_EFFECTIVE_DATE_DATA, SHOW_MODAL_ASSETGROUP } from '../../../../../../../sagas/type';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';
import { getLocalStoreString } from '../../../../../../../utils/Helper';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function RegisteredAssetEffectiveDate() {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { IssuedStoreDataDownloadQr } = useSelector(mapStateToProps)
    const [searchName, setSearchName] = useState('');
    const [isButtonEnabled, setIsButtonEnabled] = useState(true);
    const [continueModal, setContinueModal] = useState(false)
    const handleSearch = (event) => {
        const { value } = event.target
        setSearchName(value)
    }

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className='datepicker-custom-input-head'>
            <Typography sx={{ fontSize: "11px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", whiteSpace: 'nowrap' }}>Effective :</Typography>
            <button className="datepicker-custom-input" onClick={onClick} ref={ref}>
                <Typography sx={{ fontSize: "12px", fontWeight: 400, color: '#8074FF' }}>Add Date</Typography>
            </button>
        </div>
    ));

    const handleBack = () => {
        navigate(ASSETS_REGISTER_PATH)
        dispatch({ type: SHOW_MODAL_ASSETGROUP })
        dispatch({ type: HIDE_MODAL_SELECT_STORE })
    }

    const handleClearEffectiveDate = (Id) => {
        dispatch({
            type: CLEAR_EFFECTIVE_DATE,
            payload: Id
        })
    }

    const handleDateChange = (event, itemId) => {
        const selectDate = moment(event).toDate()
        console.log("selectDate", selectDate);
        dispatch({
            type: ADD_EFFECTIVEDATE_REGISTERED_ASSET,
            payload: { Id: itemId, Date: selectDate }
        })
    };
    const handleContinueButton = () => {
        setContinueModal(true)
    }

    const handleProceedButton = () => {
        const filteredData = [...IssuedStoreDataDownloadQr]
        const filterEffectiveDateData = filteredData?.filter((date) => !date?.effectiveDate?.length);
        const EffectiveDateData = filterEffectiveDateData?.map((item) => ({
            assetId: item?.assetRegisterId,
            effectiveDate: moment(item?.AddEffectiveDate).format('yyyy-MM-DD')
        }))
        const storeCode = getLocalStoreString("storeCode");
        dispatch({
            type: POST_EFFECTIVE_DATE_DATA,
            payload: EffectiveDateData,
            navigate: navigate,
            storeCode: storeCode,
        })

    }

    useEffect(() => {
        const copyIssuedStoreDataDownloadQr = [...IssuedStoreDataDownloadQr]
        const filterEffectiveDateIssuedStoreDataDownloadQr = copyIssuedStoreDataDownloadQr?.filter((date) => !date.effectiveDate?.length);
        const hasValue = filterEffectiveDateIssuedStoreDataDownloadQr?.every(obj => obj?.AddEffectiveDate !== "")
        setIsButtonEnabled(hasValue);
    }, [IssuedStoreDataDownloadQr])
    return (
        <>
            <div className='EffectiveDate-RegisteredAsset-Container' >
                <div className='EffectiveDate-RegisteredAsset-Container_header'>
                    <div className='EffectiveDate-RegisteredAsset-Container_head-height '>
                        <img className='EffectiveDate-RegisteredAsset-Container_header_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                        <span className='EffectiveDate-RegisteredAsset-Container_header_content'>Registered Assets</span>
                    </div>
                </div>
                <div className='EffectiveDate-RegisteredAsset-Container_searchcontainer'>
                    <FormControl sx={{ width: '300px', height: "30px", backgroundColor: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: 1, border: "1px solid rgba(255, 255, 255, 0.1)", display: "flex", justifyContent: "center" }}>
                        <TextField size="small" type='search' variant="outlined" placeholder='Search' onChange={handleSearch} value={searchName}
                            InputProps={{ startAdornment: (<InputAdornment position='start'>{searchName.length == 0 && <SearchIcon sx={{ color: 'rgba(255, 255, 255, 0.30)' }} />}</InputAdornment>), }} />
                    </FormControl>
                </div>
                <div className='EffectiveDate-RegisteredAsset-Container_Overflow-Container' style={{ position: "relative" }}>
                    {IssuedStoreDataDownloadQr?.length > 0 ? IssuedStoreDataDownloadQr?.filter((item) => item?.isSelected !== true).filter((element) => element?.name?.toLowerCase().includes(searchName?.toLowerCase())).map(obj => { return { ...obj, date: new Date(obj?.issuedAt) } })
                        .sort((a, b) => b.date - a.date).map((selectData) => {
                            return (
                                <Box key={selectData?.id} sx={{ margin: '0.5rem 0' }}>
                                    <Box className='EffectiveDate-RegisteredAsset-Container_Data'>
                                        <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "1px 0" }}>{selectData?.code}</Typography>
                                        <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#FFF", padding: "1px 0" }}>{selectData?.name}</Typography>
                                        <Typography sx={{ fontSize: "12px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "1px 0" }}>{selectData.description}</Typography>
                                    </Box>
                                    <Box className='EffectiveDate-RegisteredAsset-Container_EffectiveDate'>
                                        <div className='EffectiveDate-RegisteredAsset-Container_EffectiveDate_Child-Registered'>
                                            <Typography sx={{ fontSize: "11px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", padding: "0 7px" }}>Registered : {moment(selectData?.issuedAtDate).format('DD MMM YYYY')}</Typography>
                                        </div>
                                        <div className='EffectiveDate-RegisteredAsset-Container_EffectiveDate_Child-Effective'>
                                            {selectData?.effectiveDate ? <div className='EffectiveDate-RegisteredAsset-Container_EffectiveDate_Child'>
                                                <Typography sx={{ fontSize: "11px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", }}>Effective : {moment(selectData?.effectiveDate).format('DD MMM YYYY')}</Typography>
                                            </div>
                                                :
                                                <>
                                                    {selectData?.AddEffectiveDate ?
                                                        <div className='EffectiveDate-RegisteredAsset-Container_EffectiveDate_Head'>
                                                            <Typography sx={{ fontSize: "11px", fontWeight: 400, color: "rgba(255,255,255, 0.40)", whiteSpace: "nowrap" }}>Effective : </Typography>
                                                            <div className='EffectiveDate-RegisteredAsset-Container_EffectiveDate_Children'>
                                                                <Typography sx={{ fontSize: "11px", fontWeight: 400, color: '#8074FF', marginRight: '4px' }}> {moment(selectData?.AddEffectiveDate).format('DD MMM YYYY')}</Typography>
                                                                <ClearIcon sx={{ color: 'rgba(255, 255, 255, 0.30)', width: "13px", height: "13px" }} onClick={() => handleClearEffectiveDate(selectData?.id)} />
                                                            </div>
                                                        </div>
                                                        :
                                                        <div className='EffectiveDate-RegisteredAsset-Container_EffectiveDate_Child'>
                                                            <ReactDatePicker
                                                                onChange={(e) => handleDateChange(e, selectData?.id)}
                                                                dateFormat="dd-MM-yyyy"
                                                                onBlur={() => setSelectedItemId(null)}
                                                                customInput={<ExampleCustomInput />}
                                                            />
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </Box>
                                </Box>
                            )
                        }) :
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginTop: '10%' }}>
                            <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', width: '159px', height: '159px', borderRadius: '200px', background: 'rgb(222, 225, 255,0.06)', alignItems: 'center' }} >
                                <img style={{ heigth: '54px', width: '68px' }} src={requestEmptyIcon} alt="" />
                            </div>
                            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                                <Typography fontStyle='normal' fontWeight='400' fontSize='16px' lineHeight='16px' textAlign='center' color='rgba(255,255,255,0.8)' >No Items Yet</Typography>
                            </div>
                        </div>
                    }
                </div>
                <div className='EffectiveDate-RegisteredAsset-Container_Button-container'>
                    {IssuedStoreDataDownloadQr?.length > 0 && <div className='EffectiveDate-RegisteredAsset-Container_registerAssetData_buttonContainer'>
                        <button type='submit' disabled={!isButtonEnabled} className='EffectiveDate-RegisteredAsset-Container_registerAssetData_buttonContainer_active-button' onClick={handleContinueButton}>Continue</button>
                    </div>}
                </div>
                <Modal
                    open={continueModal}
                    onClose={() => setContinueModal(false)}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%" }}
                >
                    <div className='Asset-Info-Container_asset-condition-modal'>
                        <Box sx={{ backgroundColor: '#0B245F', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: "4% 4%" }}>
                            <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 700, whiteSpace: "nowrap", width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center', }}>You cannot change effective date later.</Typography>
                            <Typography sx={{ color: "#FFF", fontSize: "14px", fontWeight: 700, whiteSpace: "nowrap", width: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center', }}>Are you sure to proceed?</Typography>
                            <div className='EffectiveDate-RegisteredAsset-Container_Button-container' style={{ marginTop: "5%" }}>
                                <div className='EffectiveDate-RegisteredAsset-Container_registerAssetData_buttonContainer'>
                                    <button type='submit' className='EffectiveDate-RegisteredAsset-Container_registerAssetData_buttonContainer_Proceed' onClick={handleProceedButton}>Proceed</button>
                                    <button type='submit' className='EffectiveDate-RegisteredAsset-Container_registerAssetData_buttonContainer_No' onClick={() => setContinueModal(false)}>No</button>
                                </div>
                            </div>
                        </Box>
                    </div>
                </Modal>
            </div>
        </>
    )
}


const mapStateToProps = (state) => {
    return {
        IssuedStoreDataDownloadQr: state?.attendanceConfig?.IssuedStoreDataDownloadQr,
    }
}

export default RegisteredAssetEffectiveDate;